// @ts-nocheck


import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { DatePicker, RangePicker } from '../../../components/ant/DatePicker';


import { formatDateTimeToISOString } from '../../../lib/helpers';

import {
  Filter,
  FilterContainer,
  FilterItem,
  Selects,
  FilterButtonsContainer } from
'../../../components';

import Field from '../../../components/card/Field';

const { VehicleSelect } = Selects;

const SpoilerContent = styled.div.withConfig({ displayName: "Filter__SpoilerContent", componentId: "sc-1ygv33d-0" })(["padding:16px;"]);
















export const LicensePlateChangeFilter = ({
  filter,
  cleanFilter,
  applyFilter
}) =>
<SpoilerContent>
    <FilterContainer>
      <Filter
      cleanFilter={cleanFilter}
      applyFilter={applyFilter}
      initialValues={filter}>

        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter
      }) =>
      <>
            <FilterItem>
              <Field mBottomNone>
                <VehicleSelect
              size="small"
              value={values.vehicleId}
              optionTitle={(vehicle) => vehicle.licensePlate}
              onChange={(value) => changeValue('vehicleId', value)} />

              </Field>
            </FilterItem>

            <FilterItem>
              <Field mBottomNone>
                <DatePicker
              size="small"
              format="DD.MM.YYYY"
              value={
              values.maintenanceDate && moment.utc(values.maintenanceDate)
              }
              placeholder="Дата окончания"
              onChange={(value, dateString) =>
              changeValue(
                'maintenanceDate',
                formatDateTimeToISOString(value, dateString)
              )
              } />

              </Field>
            </FilterItem>

            <FilterItem>
              <Field mBottomNone>
                <RangePicker
              format="DD.MM.YYYY"
              size="small"
              placeholder={['Начало', 'Конец']}
              value={[
              values.startDate ? moment.utc(values.startDate) : null,
              values.endDate ? moment.utc(values.endDate) : null]
              }
              onChange={(value, dateString) => {
                const [startDate, endDate] = value;
                const [startDateString, endDateString] = dateString;
                changeValue(
                  'startDate',
                  formatDateTimeToISOString(startDate, startDateString)
                );
                changeValue(
                  'endDate',
                  formatDateTimeToISOString(endDate, endDateString)
                );
              }} />

              </Field>
            </FilterItem>

            <FilterButtonsContainer
          applyFilter={applyFilter}
          cleanFilter={cleanFilter} />

          </>
      }
      </Filter>
    </FilterContainer>
  </SpoilerContent>;


export default LicensePlateChangeFilter;
